import { jsx as x } from "react/jsx-runtime";
import { useCallback as h, useEffect as w } from "react";
import { makeClassesByStyles as C } from "../../utils/classes.js";
import { Modal as v } from "../modal/modal.js";
import E from "../../assets/2f259bd0.modal-popup.module.css";
const e = C(E), M = ({
  children: d,
  isOpen: a,
  onCloseCallback: o,
  onCloseComplete: p,
  closeModal: m,
  className: c,
  heading: i,
  subheading: f,
  copy: u,
  variant: r = "primary",
  type: s,
  shouldCloseOnEsc: n,
  panelClassName: y
}) => {
  const t = h(() => {
    o && o(), m();
  }, [m, o]);
  w(() => {
    const l = ($) => {
      $.key === "Escape" && n && a && t();
    };
    return document.addEventListener("keydown", l), () => {
      document.removeEventListener("keydown", l);
    };
  }, [t, a, n]);
  const k = e("ModalPopup", `--${r}`, `--${s}`, c), N = s === "drawer" ? {
    leaveFrom: "",
    leaveTo: "translate-x-full",
    enterFrom: "translate-x-full",
    enterTo: ""
  } : {};
  return /* @__PURE__ */ x(
    v,
    {
      isOpen: a,
      handleCloseClick: t,
      onCloseComplete: p,
      hasBackdrop: !0,
      backdropClassName: e("backdrop"),
      heading: i,
      subheading: f,
      copy: u,
      headingClassName: e("heading", `--${r}`),
      className: k,
      copyClassName: e("description", `--${r}`),
      panelClassName: e("panel", `--${s}`, `--${r}`, y),
      variant: "primary",
      ...N,
      children: d
    }
  );
};
export {
  M as ModalPopup
};
